<template>
  <!-- eslint-disable -->
  <div class="container">
    <a-table class="table" :columns="columns" :loading="loading" :dataSource="tableData" :customCell="customCell" :pagination="false">
      <template v-slot:recommendReason="text, record">
        <v-clamp autoresize :max-lines="2" class="clamp-container dfjds">
          <template>
            {{ text }}
          </template>
        </v-clamp>
      </template>

      <template v-slot:relatedUserName="text, record">
        {{ convertRelatedUserName(record) }}
      </template>
      <template v-slot:feedbackInfo="text, record">
        <v-clamp autoresize :max-lines="2" class="clamp-container feedback-text">
          <template>
            {{ feedbackText(record) }}
          </template>
          <template v-slot:after="{ toggle, expanded, clamped }">
            <a-button v-if="expanded || clamped" type="link" class="link" @click="toggle">{{ expanded ? '收起' : '展开' }}</a-button>
          </template>
        </v-clamp>
      </template>
    </a-table>
    <div class="footer" v-if="pageInfo.total > pageInfo.pageSize">
      <a-pagination :current="pageInfo.page" :total="pageInfo.total" :pageSize="pageInfo.pageSize" @change="onChange" :show-total="total => `共${total}项`" />
    </div>
  </div>
</template>
<script>
import VClamp from 'vue-clamp';
import { myRecommendList } from '@/api/humint';
import ClampMe from './clampMe.vue';
import moment from 'moment';
import { getStatusLabel } from './constants.js';

export default {
  components: {
    VClamp
  },
  data() {
    const columns = [
      {
        title: '推荐理由',
        dataIndex: 'recommendReason',
        key: 'recommendReason',
        customRender: (text, record) => {
          const jsxContent = <ClampMe maxLines={record.rowSpan * 2} text={text} class="clamp-container ss"></ClampMe>;
          return {
            children: jsxContent,
            attrs: {
              rowSpan: record.rowSpan
            }
          };
        }
      },
      {
        title: '资源情况',
        dataIndex: 'recommendResource',
        key: 'recommendResource',
        customRender: (text, record) => {
          const jsxContent = <ClampMe maxLines={record.rowSpan * 2} text={text} class="clamp-container "></ClampMe>;
          return {
            children: jsxContent,
            attrs: {
              rowSpan: record.rowSpan
            }
          };
        }
      },
      {
        title: '推荐给ta',
        dataIndex: 'receiveName',
        key: 'receiveName'
      },
      {
        title: '状态',
        key: 'status',
        dataIndex: 'status',
        customRender: getStatusLabel
      },
      {
        title: '更多进展',
        key: 'feedbackInfo',
        dataIndex: 'feedbackInfo',
        scopedSlots: {
          customRender: 'feedbackInfo'
        }
      }
    ];

    return {
      columns,
      list: [],
      loading: false,
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    tableData() {
      let list = [];
      this.list.forEach(i => {
        i.receiveInfo.forEach((j, index) => {
          let  recommendResource = '';
          try {
            recommendResource = JSON.parse(i.resource).tableRecordList.map(i => {
              return `${i.key}: ${Array.isArray(i.value) ? i.value.join(' ') : i.value}`;
            }).join(', ');
          } catch (error) {
            recommendResource = i.resource;
          }
          let obj = {
            recommendReason: i.reason,
            recommendId: i.id,
            recommendResource: recommendResource,
            rowSpan: 0
          };
          if (index === 0) {
            obj.rowSpan = i.receiveInfo.length;
          }
          list.push({
            ...obj,
            ...j
          });
        });

        if (!(i.receiveInfo.length > 0)) {
          let  recommendResource = '';
          try {
            recommendResource = JSON.parse(i.resource).tableRecordList.map(i => {
              return `${i.key}: ${Array.isArray(i.value) ? i.value.join(' ') : i.value}`;
            }).join(', ');
          } catch (error) {
            recommendResource = i.resource;
          }
          list.push({
            recommendReason: i.reason,
            recommendResource: recommendResource,
            recommendId: i.id
          });
        }
      });
      return list;
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    customCell(record, index) {
      console.log('record', record, index);

      return {
        rowSpan: record.rowSpan,
        props: {
          rowSpan: record.rowSpan
        }
      };
    },
    async query() {
      this.loading = true;
      let res = await myRecommendList({
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize
      }).finally(() => {
        this.loading = false;
      });
      if (res.code === 200) {
        this.list = res.data.list.map(i => {
          i.createAt = moment(i.createAt).format('YYYY/MM/DD');
          // i.children = i.receiveInfo;
          return i;
        });
        this.pageInfo.total = res.data.total;
      }
    },
    feedbackText(item) {
      let status = item.status;
      let keys = [
        {
          key: 'chat4',
          value: '立项'
        },
        {
          key: 'chat3',
          value: '多聊'
        },
        {
          key: 'chat2',
          value: '二聊'
        },
        {
          key: 'chat1',
          value: '一聊'
        },
        
        
       
      ];
      let chatText = keys
        .filter(i => item[i.key])
        .map(key => {
          let text = item[key.key] || '';
          text = text.replace(/\n/g, ' ');
          return `${key.value}: ${text}`;
        })
        .join('\n');
      let text = `${getStatusLabel(status)}\n${chatText}`;

      return text;
    },
    onChange(page, pageSize) {
      this.pageInfo.page = page;
      this.pageInfo.pageSize = pageSize;
      this.query();
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.clamp-container {
  @media only screen and (max-width: 800px) {
    max-width: 70px;
  }
  @media only screen and (min-width: 800px) {
    max-width: 300px;
  }
  .link {
    padding: 0 5px;
  }
}
.feedback-text {
  white-space: pre-line;
}
.feedback-button {
  display: block;
  padding: 0 5px;
  margin-bottom: 15px;
  min-width: 51px;
  &:last-child {
    margin-bottom: 0;
  }
  @media only screen and (min-width: 800px) {
    word-break: keep-all;
    white-space: nowrap;
  }
}
/deep/ .ant-table-tbody > tr > td {
  @media only screen and (max-width: 800px) {
    padding: 10px 5px;
  }
}
</style>
